(function () {
  'use strict';

  var TRAINING_ML = { none: 0, '30': 300, '60': 600, '90plus': 900 };
  var SWEAT_ML = { low: 0, normal: 250, high: 500 };
  var WEATHER_ML = { normal: 0, warm: 250, very_warm: 500 };

  var COPY = {
    nl: {
      eyebrow: 'MUSKLE · MJ App',
      title: 'Waterinname Calculator',
      intro:
        'Bereken een praktische dagelijkse waterrichtlijn op basis van je gewicht, training en omstandigheden.',
      accountNote: 'Geen account nodig. Log later in om je resultaat op te slaan.',
      backLabel: 'Terug naar MJ Apps',
      weightLabel: 'Gewicht (kg)',
      weightPlaceholder: 'Bijv. 80',
      trainingLabel: 'Trainingsduur',
      trainingNone: 'Geen training',
      training30: '30 minuten',
      training60: '60 minuten',
      training90: '90+ minuten',
      sweatLabel: 'Zweetniveau',
      sweatLow: 'Laag',
      sweatNormal: 'Normaal',
      sweatHigh: 'Hoog',
      weatherLabel: 'Weer / temperatuur',
      weatherNormal: 'Normaal',
      weatherWarm: 'Warm',
      weatherVeryWarm: 'Zeer warm',
      calculateBtn: 'Bereken mijn waterinname',
      resultTitle: 'Jouw waterrichtlijn',
      resultEmpty:
        'Vul je gegevens in en klik op berekenen om je dagelijkse waterrichtlijn te zien.',
      resultRange: '{min}–{max} L per dag',
      baseHeading: 'Basisberekening',
      baseExplain:
        'Basis: 30–35 ml per kg lichaamsgewicht per dag. Voor {weight} kg is dat ongeveer {baseMin}–{baseMax} L.',
      conditionsHeading: 'Training & omstandigheden',
      trainingExplain: {
        none: 'Zonder training voeg je geen extra water toe voor beweging.',
        '30': 'Met ongeveer 30 minuten training tellen we ongeveer 300 ml extra mee.',
        '60': 'Met ongeveer 60 minuten training tellen we ongeveer 600 ml extra mee.',
        '90plus': 'Met 90+ minuten training tellen we ongeveer 900 ml extra mee.',
      },
      sweatExplain: {
        low: 'Bij weinig zweten voeg je geen extra zweetcorrectie toe.',
        normal: 'Bij normaal zweten tellen we ongeveer 250 ml extra mee.',
        high: 'Bij veel zweten tellen we ongeveer 500 ml extra mee.',
      },
      weatherExplain: {
        normal: 'Bij normaal weer voeg je geen extra temperatuurcorrectie toe.',
        warm: 'Bij warm weer tellen we ongeveer 250 ml extra mee.',
        very_warm: 'Bij zeer warm weer tellen we ongeveer 500 ml extra mee.',
      },
      practicalTip:
        'Drink verspreid over de dag. Bij lange of intensieve training kan ook zout/elektrolyten belangrijk zijn.',
      safetyNote:
        'Dit is een praktische richtlijn voor gezonde volwassenen, geen medisch advies. Drink niet extreem veel water in korte tijd. Bij nierproblemen, hartproblemen, medicatiegebruik of twijfel: overleg met een arts.',
      sourceNote:
        'Gebaseerd op algemene hydratatierichtlijnen: waterbehoefte verschilt per persoon door gewicht, temperatuur, zweten en training.',
      errorWeight: 'Vul een geldig gewicht in (30–250 kg).',
    },
    en: {
      eyebrow: 'MUSKLE · MJ App',
      title: 'Water Intake Calculator',
      intro:
        'Calculate a practical daily water guideline based on your weight, training and conditions.',
      accountNote: 'No account needed. Later you can log in to save your result.',
      backLabel: 'Back to MJ Apps',
      weightLabel: 'Weight (kg)',
      weightPlaceholder: 'e.g. 80',
      trainingLabel: 'Training duration',
      trainingNone: 'No training',
      training30: '30 minutes',
      training60: '60 minutes',
      training90: '90+ minutes',
      sweatLabel: 'Sweat level',
      sweatLow: 'Low',
      sweatNormal: 'Normal',
      sweatHigh: 'High',
      weatherLabel: 'Weather / temperature',
      weatherNormal: 'Normal',
      weatherWarm: 'Warm',
      weatherVeryWarm: 'Very warm',
      calculateBtn: 'Calculate my water intake',
      resultTitle: 'Your water guideline',
      resultEmpty:
        'Enter your details and click calculate to see your daily water guideline.',
      resultRange: '{min}–{max} L per day',
      baseHeading: 'Base calculation',
      baseExplain:
        'Base: 30–35 ml per kg body weight per day. For {weight} kg that is about {baseMin}–{baseMax} L.',
      conditionsHeading: 'Training & conditions',
      trainingExplain: {
        none: 'With no training, no extra water is added for movement.',
        '30': 'With about 30 minutes of training, we add roughly 300 ml extra.',
        '60': 'With about 60 minutes of training, we add roughly 600 ml extra.',
        '90plus': 'With 90+ minutes of training, we add roughly 900 ml extra.',
      },
      sweatExplain: {
        low: 'With little sweating, no extra sweat adjustment is added.',
        normal: 'With normal sweating, we add roughly 250 ml extra.',
        high: 'With heavy sweating, we add roughly 500 ml extra.',
      },
      weatherExplain: {
        normal: 'In normal weather, no extra temperature adjustment is added.',
        warm: 'In warm weather, we add roughly 250 ml extra.',
        very_warm: 'In very warm weather, we add roughly 500 ml extra.',
      },
      practicalTip:
        'Drink spread across the day. For long or intense training, salt/electrolytes may also matter.',
      safetyNote:
        'This is practical guidance for healthy adults, not medical advice. Do not drink extreme amounts of water in a short time. If you have kidney problems, heart problems, use medication or have doubts: consult a doctor.',
      sourceNote:
        'Based on general hydration guidance: water needs differ per person depending on body weight, temperature, sweating and training.',
      errorWeight: 'Enter a valid weight (30–250 kg).',
    },
  };

  function init(root) {
    if (!root || root.dataset.mjWaterIntakeInit === '1') return;
    root.dataset.mjWaterIntakeInit = '1';

    var lang = root.dataset.defaultLang === 'en' ? 'en' : 'nl';
    var els = {
      langBtns: root.querySelectorAll('[data-mj-lang]'),
      back: root.querySelector('[data-mj-copy="backLabel"]'),
      calculateBtn: root.querySelector('[data-mj-action="calculate"]'),
      resultEmpty: root.querySelector('[data-mj-result-empty]'),
      resultPanel: root.querySelector('[data-mj-result-panel]'),
      resultRange: root.querySelector('[data-mj-result-range]'),
      resultBase: root.querySelector('[data-mj-result-base]'),
      resultConditions: root.querySelector('[data-mj-result-conditions]'),
      error: root.querySelector('[data-mj-error]'),
      weight: root.querySelector('[data-mj-input="weight"]'),
    };

    function t(key) {
      var parts = key.split('.');
      var val = COPY[lang];
      for (var i = 0; i < parts.length; i += 1) {
        if (!val) return key;
        val = val[parts[i]];
      }
      return val || key;
    }

    function getSelected(name) {
      var nodes = root.querySelectorAll('[data-mj-input="' + name + '"]');
      for (var i = 0; i < nodes.length; i += 1) {
        if (nodes[i].checked) return nodes[i].value;
      }
      return '';
    }

    function round1(value) {
      return Math.round(value * 10) / 10;
    }

    function mlToL(ml) {
      return round1(ml / 1000);
    }

    function applyCopy() {
      root.querySelectorAll('[data-mj-copy]').forEach(function (node) {
        var key = node.getAttribute('data-mj-copy');
        if (!key || key === 'backLabel') return;
        var text = t(key);
        if (typeof text === 'string') node.textContent = text;
      });

      if (els.back) els.back.textContent = t('backLabel');
      if (els.weight) els.weight.placeholder = t('weightPlaceholder');
      if (els.calculateBtn) els.calculateBtn.textContent = t('calculateBtn');

      root.querySelectorAll('[data-mj-option="training"]').forEach(function (node) {
        var opt = node.getAttribute('data-mj-option-value');
        if (opt === 'none') node.textContent = t('trainingNone');
        if (opt === '30') node.textContent = t('training30');
        if (opt === '60') node.textContent = t('training60');
        if (opt === '90plus') node.textContent = t('training90');
      });

      root.querySelectorAll('[data-mj-option="sweat"]').forEach(function (node) {
        var opt = node.getAttribute('data-mj-option-value');
        if (opt === 'low') node.textContent = t('sweatLow');
        if (opt === 'normal') node.textContent = t('sweatNormal');
        if (opt === 'high') node.textContent = t('sweatHigh');
      });

      root.querySelectorAll('[data-mj-option="weather"]').forEach(function (node) {
        var opt = node.getAttribute('data-mj-option-value');
        if (opt === 'normal') node.textContent = t('weatherNormal');
        if (opt === 'warm') node.textContent = t('weatherWarm');
        if (opt === 'very_warm') node.textContent = t('weatherVeryWarm');
      });

      els.langBtns.forEach(function (btn) {
        var isActive = btn.getAttribute('data-mj-lang') === lang;
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        btn.classList.toggle('mj-app__lang-btn--active', isActive);
      });

      root.setAttribute('data-mj-lang', lang);
    }

    function calculate() {
      if (els.error) {
        els.error.hidden = true;
        els.error.textContent = '';
      }

      var weight = parseFloat(String(els.weight && els.weight.value).replace(',', '.'));
      if (!weight || weight < 30 || weight > 250) {
        if (els.error) {
          els.error.textContent = t('errorWeight');
          els.error.hidden = false;
        }
        return;
      }

      var training = getSelected('training') || 'none';
      var sweat = getSelected('sweat') || 'normal';
      var weather = getSelected('weather') || 'normal';

      var baseMinMl = weight * 30;
      var baseMaxMl = weight * 35;
      var addMl =
        (TRAINING_ML[training] || 0) +
        (SWEAT_ML[sweat] || 0) +
        (WEATHER_ML[weather] || 0);

      var totalMinL = mlToL(baseMinMl + addMl);
      var totalMaxL = mlToL(baseMaxMl + addMl);

      if (els.resultRange) {
        els.resultRange.textContent = t('resultRange')
          .replace('{min}', String(totalMinL))
          .replace('{max}', String(totalMaxL));
      }

      if (els.resultBase) {
        els.resultBase.textContent = t('baseExplain')
          .replace('{weight}', String(weight))
          .replace('{baseMin}', String(mlToL(baseMinMl)))
          .replace('{baseMax}', String(mlToL(baseMaxMl)));
      }

      if (els.resultConditions) {
        els.resultConditions.textContent = [
          t('trainingExplain.' + training),
          t('sweatExplain.' + sweat),
          t('weatherExplain.' + weather),
        ].join(' ');
      }

      if (els.resultEmpty) els.resultEmpty.hidden = true;
      if (els.resultPanel) els.resultPanel.hidden = false;
      root.classList.add('mj-app--has-result');
    }

    els.langBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var next = btn.getAttribute('data-mj-lang');
        if (next === 'nl' || next === 'en') {
          lang = next;
          applyCopy();
          if (root.classList.contains('mj-app--has-result')) calculate();
        }
      });
    });

    if (els.calculateBtn) {
      els.calculateBtn.addEventListener('click', calculate);
    }

    applyCopy();
  }

  document.querySelectorAll('[data-mj-water-intake-app]').forEach(init);
})();
